import { useSelector } from 'react-redux'
import { FullScreenCard } from '~/components/FullScreenCard'
import {
    ManagedModal,
    ModalWithOptions,
} from '~/state/modalManager/modalManagerSlice'
import { getVisibleModal } from '~/state/modalManager/selectors'
import { SubscribeModal } from '../SubscribeModal'
import { AcceptTOSModal } from '../Common/AcceptTOSModal'
import { SunsetDeletionPrompt } from '../Common/SunsetDeletionPrompt'

export const ModalPlacement = () => {
    const modal = useSelector(getVisibleModal)

    if (modal?.type === ManagedModal.TermsOfService) {
        return <AcceptTOSModal />
    }

    if (modal?.type === ModalWithOptions.FullScreenMessage) {
        return <FullScreenCard card={modal.options} />
    }

    if (modal?.type === ManagedModal.Subscription) {
        return <SubscribeModal />
    }

    if (modal?.type === ManagedModal.SunsetDeletion) {
        return <SunsetDeletionPrompt />
    }

    return null
}
